<template>
  <a-spin :spinning="loading">
    <router-link to="/users/new">
      <a-button type="primary" style="margin-bottom: 10px;"
        ><i
          class="fe fe-user-plus font-size-15"
          title="Add user"
          style="margin-right: 10px;"
        />
        New user
      </a-button>
    </router-link>
    <div style="text-align: center;">
      <a-table
        :columns="columns"
        :data-source="dataSource"
        :pagination="{ pageSize: 50 }"
        :row-key="(record) => record.id"
      >
        <span slot="participantAndVatCode" slot-scope="text, record">
          <span v-if="record.participant">
            {{ record.participant.name }} ( {{ record.participant.vatCode }} )
          </span>
          <span v-else>
            <a-tag :color="'volcano'">Unassigned</a-tag>
          </span>
        </span>

        <span slot="lastLogin" slot-scope="text, record">
          <a-tag :color="record.lastOnlineAt === null ? 'volcano' : 'green'">
            {{
              record.lastOnlineAt === null ? 'Never' : record.lastOnlineBefore
            }} </a-tag
          ><br />
          {{
            record.lastOnlineAt === null
              ? ''
              : `Last active at: ${record.lastOnlineAt}`
          }}
        </span>

        <span slot="actions" slot-scope="record">
          <a-popconfirm
            title="Are you sure you want to delete this user?"
            ok-text="Yes"
            cancel-text="No"
            @confirm="deleteUser(record.id)"
            ><a
              ><i
                class="fe fe-user-x align-middle text-danger"
                title="Delete user" /></a
          ></a-popconfirm>
          <router-link :to="`/users/edit/${record.id}`">
            <a
              ><i
                class="fe fe-edit align-middle text-gray-6"
                title="Edit user"
                style="margin-left: 10px;"
            /></a>
          </router-link>

          <!-- <a-popconfirm
            style="margin-left: 10px"
            title="Are you sure you want to ed this user?"
            ok-text="Yes"
            cancel-text="No"
            @confirm="deleteUser(record.id)"
            ><a
              ><i
                class="fe fe-user-x  align-middle text-gray-6"
                title="Delete user" /></a
          ></a-popconfirm> -->
        </span>
      </a-table>
    </div>
  </a-spin>
</template>

<script>
import { UserService } from '@/services/api'

const columns = [
  // {
  //   dataIndex: 'id',
  //   key: 'id',
  //   title: '#',
  //   scopedSlots: { customRender: 'id' },
  // },
  {
    title: 'Username',
    dataIndex: 'username',
    key: 'username',
  },
  {
    title: "User's display name",
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Participant (VAT code)',
    dataIndex: 'participantAndVatCode',
    key: 'participantAndVatCode',
    scopedSlots: { customRender: 'participantAndVatCode' },
  },

  {
    title: 'Last active',
    dataIndex: 'lastLogin',
    scopedSlots: { customRender: 'lastLogin' },
    align: 'center',
  },
  {
    title: 'Actions',
    scopedSlots: { customRender: 'actions' },
    align: 'center',
  },
]

export default {
  components: {},
  data() {
    return {
      columns: columns,
      dataSource: [],
      loading: false,
    }
  },
  methods: {
    fetchUsers() {
      UserService.get().then((response) => {
        this.dataSource = response.data.data
      })
    },
    deleteUser(id) {
      UserService.delete(id).then((response) => {
        this.fetchUsers()
      })
    },
  },
  mounted() {
    this.fetchUsers()
  },
}
</script>
